<template>
    <div>
        <a-row style="top: 20px;">
            <a-col :span="20" :offset="2">
                <a-row :gutter="[24, 16]">
                    
                    <a-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }"
                        v-for="(item, index) in dataDirectContact" :key="'card' + index">
                        <a-alert :style="{ borderRadius: '10px', border: '0px', backgroundColor: '#F5F5F5' }">
                            
                            <div slot="message">
                                
                                <a-list item-layout="horizontal" style="height: 370px">
                                    <a-list-item class="">
                                        <a-list-item-meta>
                                            <div slot="description" style="font-size: 20px;padding: 5px">
                                                <div v-for="(list, index) in [
                                                    { label: '', objname: 'phoneA', icon: 'mobile' }, { label: '', objname: 'phoneB', icon: 'phone' } , 
                                                    { label: '', objname: 'fax', icon: 'container' }, { label: '', objname: 'website', icon: 'compass' }, { label: '', objname: 'facebook', icon: 'facebook' }, { label: '', objname: 'ig', icon: 'instagram' }, { label: '', objname: 'Line', icon: 'wechat' }, { label: '', objname: 'mailA', icon: 'mail' }, { label: '', objname: 'location', icon: 'environment' }
                                                ]" :key="'con' + index">
                                                        <p style="font-size: 14px;color: #000000;"
                                                            class="mt-5 mb-10 font-web font-weight-bold"
                                                            v-if="item[list.objname] !== '#' && item[list.objname] !== '' && item[list.objname] !== ' ' && item['social'][list.objname] !== ''"
                                                        >
                                                            <strong v-if="list.objname !== 'Line'">
                                                                <a-icon
                                                                    :theme="['fax', 'website', 'facebook', 'ig'].includes(list.objname) ? 'filled' : 'twoTone'"
                                                                    two-tone-color="#6527BE" :style="{ color: '#6527BE' }"
                                                                    class="mr-5" :type="list.icon" /> :
                                                            </strong>
                                                            <span v-else>
                                                                <img class="mr-5" :style="{ width: '15px', height: '15px' }" src="images/iconLine.png" alt="imag_carddirec_1"> :
                                                            </span>
                                                            <span v-if="list.objname == 'mailA'">
                                                                <span class="font-web mt-0 ml-5 mb-5"
                                                                    v-for="(lm, index) in item[list.objname].split(',')"
                                                                    :key="'in' + index"
                                                                >
                                                                    <a :class="index > 0 ? 'ml-25' : ''" :style="{ fontSize: '16px' }" target="_blank" :href="'mailto:' + lm">&nbsp;{{ lm }}</a>
                                                                    <br>
                                                                </span>
                                                            </span>
                                                            <span v-else
                                                                :style="['phoneA', 'phoneB'].includes(list.objname) && !['-', '' , ''].includes(item[list.objname]) ? { borderRadius: '15px', fontSize: '14px', fontWeight: 700, } : ''"
                                                                class="ml-5 font-web">
                                                                &nbsp;&nbsp;{{
                                                                    ['fax', 'facebook', 'Line', 'ig'].includes(list.objname) ?
                                                                    item['social'][list.objname] : item[list.objname]
                                                                }}
                                                                <span>
                                                                    <a target="_blank" v-if="list.objname === 'website'"
                                                                        :href="item['social'][list.objname]">{{
                                                                            item['social'][list.objname].slice(0, 30) }}...</a>
                                                                </span>
                                                                &nbsp;&nbsp;
                                                            </span>
                                                        </p>
                                                </div>
                                            </div>
                                            <div :style="{ marginTop: '10px', backgroundColor: '#F5F5F5', padding: '10px' }" class="text-center" slot="title">
                                                <span class="font-web text-gray-dark mt-20 mb-10">
                                                    <h6 :style="{ fontWeight: 'bold', color: '#000000' }" v-html="item.textName"
                                                        class="mt-5 mb-15 font-weight-bold text-dark font-web"></h6>
                                                    <span v-if="!['', ' ', null , '-'].includes(item.textNameTh)" :style="{ fontSize: '14px' }" class="font-web text-muted">{{
                                                        item.textNameTh }}</span>
                                                </span>
                                            </div>
                                        </a-list-item-meta>
                                    </a-list-item>
                                </a-list>
                            </div>
                        </a-alert>
                    </a-col>
                </a-row>
            </a-col>
        </a-row>
    </div>
</template>

<script>
export default {
    props: {
        dataDirectContact: {
            type: Array,
            default: () => ([])
        }
    },
    data() {
        return {

        }
    },
    methods: {
        sortItem(val) {
            val.sort(function (a, b) {
                let nameA = a.textName.toUpperCase();
                let nameB = b.textName.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });
        },
    }
}
</script>

<style></style>